import React from "react";
import './style.scss';
import HeroSection from "../../../Component/HeroSection/HeroSection";
import AboutSection from "../../../Component/AboutSection/AboutSection";
import Whatwedo from "../../../Component/WhatWeDo/WhatWeDo";
import OurApproach from "../../../Component/OurApproach/OurApproach";
import WhyChooseus from "../../../Component/WhyChooseus/WhyChooseus";
import TeamThumbslider from "../../../Component/Team/Teamslider";
import CaseStudy from "../../../Component/caseStudy/casestudy";
import JointeamSection from "../../../Component/JointeamSection/JointeamSection";
import SpecialitySection from "../../../Component/specialitySection/specialitySection";
import TeamSection from "../../../Component/Team/Team/Team";
import Count from "../../../Component/Count/Count";

const Home = () => {


    return (
        <>
            <div className="container" style={{height:'100%'}}>
                <div style={{height:'100%',width:'1px',background:'#00000010',position:'fixed',top:'0',zIndex:'-1',opacity:'0.6'}}></div>
                <div style={{height:'100%',width:'1px',background:'#00000010',position:'fixed',top:'0',left:'30%',zIndex:'-1',opacity:'0.6'}}></div>                
                <div style={{height:'100%',width:'1px',background:'#00000010',position:'fixed',top:'0',zIndex:'-1',opacity:'0.6'}}></div>
                <div style={{height:'100%',width:'1px',background:'#00000010',position:'fixed',top:'0', right:'15%',zIndex:'-1',opacity:'0.6'}}></div>
            </div>
            <HeroSection />
            <Whatwedo/>
            <SpecialitySection/>
            <Count />
            <WhyChooseus />
            {/* <CaseStudy/> */}
            {/* <TeamThumbslider/> */}
            <JointeamSection/>  
            {/* <AboutSection /> */}
            {/* <OurApproach /> */}
        </>
    )
}

export default Home;